var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 40,
    fill: "none",
    viewBox: "0 0 38 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m22.9 31.905.01-.01 10.254-10.572q.122-.127.215-.277l.16-.304.068-.208v-.152a2 2 0 0 0 0-.706v-.304l-.12-.235a1.7 1.7 0 0 0-.256-.36L22.91 8.163a1.717 1.717 0 0 0-2.483-.01l-.01.01a1.9 1.9 0 0 0 0 2.56l6.113 6.324c.259.273.255.71-.01.978a.66.66 0 0 1-.46.198H6.1c-.97 0-1.756.812-1.756 1.813s.786 1.813 1.756 1.813h19.96c.37.005.667.32.661.701a.7.7 0 0 1-.191.475l-6.113 6.296a1.9 1.9 0 0 0 0 2.574c.683.71 1.795.715 2.483.01"
  })));
};
export default SvgArrow;